import React from 'react';
import { Box, BoxProps } from '@material-ui/core';
import styled from 'styled-components';

type Position = 'left' | 'right';

interface Props extends BoxProps {
  imagePosition?: Position;
}

interface SubComponents {
  Title: React.FC<BoxProps>;
  Description: React.FC<BoxProps>;
  Image: React.FC<BoxProps>;
}

const TwoColumnsWithImage: React.FC<Props> & SubComponents = ({
  imagePosition = 'right',
  children,
  ...boxProps
}) => {
  return (
    <LayoutGrid imagePosition={imagePosition} {...boxProps}>
      {children}
    </LayoutGrid>
  );
};
const TitleWrapper = styled(Box)`
  grid-area: title;

  ${({ theme }) => theme.breakpoints.up('md')} {
    align-self: end;
  }
`;

const DescriptionWrapper = styled(Box)`
  grid-area: description;
`;

const ImageWrapper = styled(Box)`
  grid-area: image;
  justify-self: center;
`;

TwoColumnsWithImage.Image = ImageWrapper;
TwoColumnsWithImage.Title = TitleWrapper;
TwoColumnsWithImage.Description = DescriptionWrapper;

const LayoutGrid = styled(Box)<{ imagePosition: Position }>`
  display: grid;
  justify-items: center;

  place-content: center;
  grid-row-gap: ${({ theme }) => theme.spacing(3)}px;
  grid-template-columns: 1fr;
  grid-template-areas:
    'title'
    'image'
    'description';

  ${({ theme }) => theme.breakpoints.up('md')} {
    justify-items: ${({ imagePosition }) =>
      imagePosition === 'left' ? 'end' : 'start'};

    padding-top: ${({ theme }) => theme.spacing(0)}px;

    grid-template-columns: ${({ imagePosition }) =>
      imagePosition === 'left'
        ? '1fr minmax(200px, 500px)'
        : 'minmax(200px, 500px) 1fr'};

    grid-template-areas: ${({ imagePosition }) =>
      imagePosition === 'left'
        ? `
        'image title'
        'image description'
    `
        : `
        'title image'
        'description image'
    `};
  }
`;

export default TwoColumnsWithImage;
